module.exports = __webpack_public_path__ + "img/thirdImage.e413b5dd.png";